import React from "react";
import { Card } from "react-bootstrap";
import { CheckCircle, Zap, Trophy, Target, Heart } from "lucide-react";
import "./Differentiators.css";

const differentiators = [
  {
    icon: CheckCircle,
    title: "One-Stop Service",
    description:
      "Comprehensive solutions from initial consultation to deal closure, eliminating the need for multiple advisors.",
  },
  {
    icon: Zap,
    title: "Speed & Professionalism",
    description:
      "Efficient processes backed by deep expertise ensure quick turnaround without compromising quality.",
  },
  {
    icon: Trophy,
    title: "Proven Success",
    description:
      "Track record of successful transactions exceeding $2B, with a 100% client satisfaction rate.",
  },
  {
    icon: Target,
    title: "Tailored Options",
    description:
      "Customized financing structures that align perfectly with your strategic objectives and risk profile.",
  },
  {
    icon: Heart,
    title: "Personalized Service",
    description:
      "Dedicated relationship managers who understand your business and provide hands-on support throughout.",
  },
];

const Differentiators = () => {
  return (
    <section className="differentiators-section">
      <div className="container text-center">

        <h2 className="display-3 fw-bold66 mb-3 ma-alighn">
          What Sets Us <span className="text-accent">Apart</span>
        </h2>
        <p className="section-subtitle mb-5 ma-alighn">
          Our distinctive approach delivers unmatched value to clients across Africa
        </p>

        <div className="differentiators-grid">
          {differentiators.map((item, index) => (
            <Card key={index} className="differentiator-card">
              <div className="icon-wrapper2 mb-3">
                <item.icon className="icon-accent" />
              </div>
              <div>
                <h4 className="fw-bold mb-2">{item.title}</h4>
                <p className="card-text">{item.description}</p>
              </div>
            </Card>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default Differentiators;